<template>
     <CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-lg-6">
                        <CList @FiltrarC="Recuperar" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
                            <template slot="Filtros">
                                <div class="col-auto">
                                    <label class="col-form-label text-primary">Por</label>
                                </div>
                                <div class="col-auto">
                                    <select @change="Recuperar" v-model="Filtro.IdProductoCategoria" class="form-select form-control-search">
                                        <option value="">Todos</option>
                                        <option v-for="(item,index) in Categorias" :key="index" :value="item.IdProductoCategoria">{{item.Nombre}}</option>
                                    </select>
                                </div>
                            </template>
                            <template slot="header">
                                <th :class="StyleTh+' text-center'">#</th>
                                <th :class="StyleTh" width="60%">Nombre</th>
                                <th :class="StyleTh">Ver Presentaciones</th>
                            </template>
                            <template slot="body">
                                <tr v-for="(lista,index) in Materiales" :key="index">
                                    <td class="text-center"><p :class="StyleTd">{{ (index+1) }}</p></td>
                                    <td><h6 :class="StylePr">{{lista.Nombre}}</h6></td>
                                    <td>
                                        <!-- <button v-show="lista.ShowButton" @click="SeleccionarPresentacion(lista)" type="button" v-b-tooltip.hover.Top title="Seleccionar Presentación" class="btn btn-warning btn-icon"><i class="fas fa-check-circle"></i></button> -->
                                        <button class="btn btn-link text-primary px-3 mb-0 mr-1" @click="RecuperarPresentaciones(lista)">
                                            <i class="fas fa-eye text-primary me-2" aria-hidden="true"></i> Ver
                                        </button>
                                    </td>
                                </tr>
                                <CSinRegistros :pContIF="Materiales.length" :pColspan="4"></CSinRegistros>
                            </template>
                        </CList>
                    </div>

                    <div class="col-lg-6">
                        <div class="card">
                            <div class="card-header">
                                <h6>Presentaciones</h6>
                            </div>
                            <div class="card-body">
                                <div class="table-responsive">
                                    <CLoader :pConfigLoad="ConfigLoadPresentaciones">
                                        <template slot="BodyFormLoad">
                                            <table class="table align-items-center mb-0">
                                                <thead>
                                                    <tr>
                                                        <th :class="StyleTh+' text-center'">#</th>
                                                        <th :class="StyleTh">Unidad</th>
                                                        <th :class="StyleTh">Sub Unidad</th>
                                                        <th :class="StyleTh">Costo</th>
                                                        <th :class="StyleTh">Proveedor</th>
                                                        <th :class="StyleTh">Seleccionar</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(lista,index) in Presentaciones" :key="index">
                                                        <td class="text-center"><p :class="StyleTd">{{ (index+1) }}</p></td>
                                                        <td><p :class="StyleTd">{{ lista.unidad_material.Nombre }}</p></td>
                                                        <td><p :class="StyleTd">{{ lista.sub_unidad_material.Cantidad + ' ' + lista.sub_unidad_material.SubUnidad }}</p></td>
                                                        <td><p :class="StyleTd">$ {{ lista.Costo }}</p></td>
                                                        <td><p :class="StyleTd">{{ lista.NombreComercial }}</p></td>
                                                        <td v-if="BndMostrarBotones">
                                                            <button v-show="lista.ShowButton" @click="SeleccionarPresentacion(lista)" class="btn btn-link text-primary px-3 mb-0 mr-1">
                                                                <i class="fas fa-check-circle text-primary me-2" aria-hidden="true"></i> Agregar
                                                            </button>
                                                        </td>
                                                    </tr>
                                                    <CSinRegistros :pContIF="Presentaciones.length" :pColspan="6"></CSinRegistros>
                                                </tbody>
                                            </table>
                                        </template>
                                    </CLoader>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
        </template>
     </CLoader>
</template>

<script>
import Configs from '@/helpers/VarConfig.js';
export default {
    name: 'FormProveedores',
    props:['poBtnSave','objPresentacionesSeleccionadas','objPresentacionesRegistradas'],
    data(){
        return{
            ConfigLoad:{
                ShowLoader: false,
                ClassLoad: false,
            },
            Emit: this.poBtnSave.EmitSeccion,
            ConfigList:{
                Title:'Materiales',
                BtnNewShow:false,
                ShowTitleFirst: false,
                ShowLoader: false,
                ShowFooter: false,
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
                IdProductoCategoria:""
            },
            segurity: {},
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
            Materiales:[],
            Presentaciones:[],
            Categorias:[],
            BndMostrarBotones:false,
            ConfigLoadPresentaciones:{
                ShowLoader:false,
                ClassLoad:true
            }
        }
    },
    methods: {
        Recuperar(){
            this.ConfigList.ShowLoader=true;
            this.$http.get('materiales',
            {
                params:{
                    Nombre: this.Filtro.Nombre,
                    Entrada: this.Filtro.Entrada,
                    Pag: this.Filtro.Pagina,
                    IdProductoCategoria:this.Filtro.IdProductoCategoria
                }
            }).then((res) => {
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                this.Materiales=res.data.data.data;
            }).finally(()=>{
                this.ConfigList.ShowLoader = false;
                this.ConfigLoad.ShowLoader = false;
            });
        },
        RecuperarPresentaciones(item){
            this.ConfigLoadPresentaciones.ShowLoader=true;
            this.$http.get('materialespresentacion/inner',{
                params:{
                    IdMaterial:item.IdMaterial
                }}).then((res)=>{
                    this.Presentaciones=res.data.data;
                    this.Presentaciones.map((el)=>{return el.ShowButton=true;});
                }).finally(()=>{
                    this.FiltrarBoton();
                    this.ConfigLoadPresentaciones.ShowLoader=false;
                })
        },
        SeleccionarPresentacion(item){
            this.bus.$emit('SeleccionarPresentacion',item);
        },
        FiltrarBoton(){
            this.BndMostrarBotones=false;
            let BndCambio=false;
            let Contador=0;
            if (this.objPresentacionesRegistradas.length>0) {
                this.Presentaciones.forEach(element => {
                    BndCambio=this.objPresentacionesRegistradas.some((el)=>{return el.IdMaterialPresentacion==element.IdMaterialPresentacionxProveedor});
                    if (BndCambio) {
                        Contador++;
                    }
                });
                if (Contador>=1) {
                    this.Presentaciones.map((el)=>{return el.ShowButton=false;})
                }
            }
            BndCambio=false;
            Contador=0;

            if (this.objPresentacionesSeleccionadas.length>0) {
                this.Presentaciones.forEach(element => {
                    BndCambio=this.objPresentacionesSeleccionadas.some((el)=>{return el.IdMaterialPresentacion==element.IdMaterialPresentacion});
                    if (BndCambio) {
                        Contador++;
                    }
                });
                if (Contador>=1) {
                    this.Presentaciones.map((el)=>{return el.ShowButton=false;})
                }
            }
            this.BndMostrarBotones=true;
        },
        ListaCategorias(){
            this.$http.get("productosCategoria/simple"
            ).then((res)=>{
                this.Categorias=res.data.data;
            })
        }
    },
    created() {
        this.ListaCategorias();
        this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            // this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Recuperar();
        });
    }
}
</script>